// merchant-pc 入口 (PR-22a-3 RFC-20260514-010)
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';

import '@dajie/shared/styles/tokens.css';
import './style.css';

import App from './App.vue';
import { router } from './router/index.js';

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.use(ElementPlus, { locale: zhCn });
app.mount('#app');
